import clsx from 'clsx';
import { Figure } from '../layouts';

export default function Background({ source, className }) {
  return (
    <Figure
      role="img"
      style={{ backgroundImage: `url(${source})` }}
      className={clsx(
        'absolute inset-0 -z-[1] h-full w-full bg-white bg-cover bg-[50%_center] bg-no-repeat',
        className
      )}
    />
  );
}
